export default __webpack_public_path__ + "static/media/card1.47268394.png";